import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import { Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNavigate } from "react-router-dom";

interface IProps {
  title?: string;
  time?: string;
}

const FeedbackMetricHeader = ({ title, time }: IProps) => {
  const navigate = useNavigate();

  const handleRedirectTicketDetailsViewAll = () => {
    navigate("/topics");
  };
  return (
    <Grid
      container
      sx={{
        background: "#dbdce04d",
        borderRadius: "8px 8px 0 0",
        height: "44px",
      }}
    >
      <Grid
        item
        container
        md={6}
        xs={12}
        sx={{
          paddingLeft: "20px",
        }}
        alignItems="center"
        gap="16px"
      >
        <Typography sx={{ fontWeight: 700, fontSize: "0.8rem" }}>
          {title}
        </Typography>
        {/* <Typography
          sx={{
            display: "flex",
            alignItems: "center",
            fontSize: "12px",
            color: "#0F2552",
            fontWeight: 500,
          }}
        >
          {time} hours
          <KeyboardArrowDownIcon
            sx={{ marginLeft: "5px", color: "#848A95", fontSize: "16px" }}
          />
        </Typography> */}
      </Grid>
      <Grid
        item
        container
        md={6}
        xs={12}
        justifyContent="end"
        sx={{
          paddingRight: "2px",
        }}
        alignItems="center"
      >
        <Button
          variant="text"
          sx={{
            color: "#2858D3",
            fontWeight: 700,
          }}
          onClick={handleRedirectTicketDetailsViewAll}
        >
          VIEW ALL
        </Button>
      </Grid>
    </Grid>
  );
};

export default FeedbackMetricHeader;
